export const Title = () => {
  return (
    <div className="flex flex-col w-full h-screen bg-gradient-to-t from-black to-indigo-900 space-y-10 items-center text-center px-10">
      <h1 className="text-6xl sm:text-7xl mt-[25vh] font-thin">Gus Hauge</h1>
      <h2 className="text-base sm:text-xl font-light">
        Creating reliable, scalable, human-centered software
      </h2>
    </div>
  );
};
